// extracted by mini-css-extract-plugin
export default {"-large":"icon-group-module__-large--potnl","container":"icon-group-module__container--SH6mn","divider":"icon-group-module__divider--hV7Dk"};